import React from "react";
import { Stack } from "@mui/material";
import {
  TextInputField,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Instance } from "mobx-state-tree";
import { BoundedNameModel } from "../../../models/BoundedNameModel";
import { getAllowedDomainFieldValidationErrorMessage } from "../../utils/getAllowedDomainValidationErrorMessage";

const FIELD_WIDTH = "75%";

interface AllowedDomainFormProps {
  domainName: Instance<typeof BoundedNameModel>;
  domain: Instance<typeof BoundedNameModel>;
  disableForm?: boolean;
}

export const AllowedDomainForm: React.FC<AllowedDomainFormProps> = observer(
  ({ domainName, domain, disableForm = false }) => {
    const { t } = useTranslation();
    const translate = t as unknown as (key: string) => string;
    const spacing = useSpacing();

    const validationErrors = getAllowedDomainFieldValidationErrorMessage(t, {
      domainName: domainName.validationError,
      domain: domain.validationError,
    });

    return (
      <Stack gap={spacing.spaceLG} width="100%">
        <Stack width={FIELD_WIDTH}>
          <TextInputField
            name="allowedDomainName"
            label={translate("emailCycles.allowedDomainsNameLabel")}
            value={domainName.name}
            type="text"
            onTextChange={(value) => domainName.setName(value)}
            placeholder={translate("emailCycles.allowedDomainsNamePlaceholder")}
            error={!!validationErrors.domainName}
            helperText={validationErrors.domainName}
            required
            disabled={disableForm}
          />
        </Stack>
        <Stack width={FIELD_WIDTH}>
          <TextInputField
            name="allowedDomain"
            label={translate("emailCycles.allowedDomainsDomainLabel")}
            value={domain.name}
            type="text"
            onTextChange={(value) => domain.setName(value)}
            placeholder={translate(
              "emailCycles.allowedDomainsDomainPlaceholder",
            )}
            error={!!validationErrors.domain}
            helperText={validationErrors.domain}
            required
            disabled={disableForm}
          />
        </Stack>
      </Stack>
    );
  },
);
